import React from "react";
import { Link } from "react-router-dom";
import { Star, MapPin, SealCheck } from "@phosphor-icons/react";
import WishlistHeart from "./WishlistHeart";

export default function HotelCard({ hotel }) {
  const img = (hotel.images && hotel.images[0]) || "";
  return (
    <Link
      to={`/hotels/${hotel.id}`}
      className="group block bg-white rounded-2xl border border-black/5 overflow-hidden hover:-translate-y-1 hover:shadow-xl transition-[transform,box-shadow] duration-300"
      data-testid={`hotel-card-${hotel.id}`}
    >
      <div className="relative aspect-[4/3] overflow-hidden bg-stone">
        <img
          src={img}
          alt={hotel.name}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          loading="lazy"
        />
        <div className="absolute top-4 left-4 flex gap-2">
          <div className="px-3 py-1 rounded-full glass text-xs tracking-wider uppercase text-midnight">
            {hotel.property_type}
          </div>
          {hotel.is_verified && (
            <div className="px-2.5 py-1 rounded-full bg-emerald-600 text-white text-[10px] tracking-wider uppercase flex items-center gap-1" data-testid={`verified-${hotel.id}`}>
              <SealCheck size={12} weight="fill" /> Verified
            </div>
          )}
        </div>
        <div className="absolute top-4 right-4 flex items-center gap-2">
          <WishlistHeart kind="hotel" itemId={hotel.id} />
          <div className="flex items-center gap-1 px-3 py-1 rounded-full bg-midnight/85 text-bone text-xs">
            <Star size={12} weight="fill" className="text-gold" />
            <span>{hotel.rating}</span>
          </div>
        </div>
      </div>
      <div className="p-6">
        <h3 className="font-serif text-xl text-midnight mb-1 group-hover:text-gold transition-colors">
          {hotel.name}
        </h3>
        <div className="flex items-center gap-1 text-sm text-neutral-500 mb-4">
          <MapPin size={14} weight="duotone" />
          <span>{hotel.city}</span>
        </div>
        <div className="flex items-end justify-between pt-3 border-t border-black/5">
          <div>
            <p className="text-xs uppercase tracking-widest text-neutral-500">Per night</p>
            <p className="font-serif text-2xl text-midnight">
              ₹{hotel.price_per_night.toLocaleString("en-IN")}
            </p>
          </div>
          <span className="text-xs text-neutral-500 tracking-wide">
            {hotel.rooms_available} rooms left
          </span>
        </div>
      </div>
    </Link>
  );
}
